var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"max-height":"1000"}},[_c('el-table-column',{attrs:{"prop":"state","label":"状态","min-width":"150","formatter":_vm.stateFormat}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"co","label":"数量","min-width":"120"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76a9bdde","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/admincreditlist.vue
// module id = null
// module chunks = 